/**
 * A reload's placeholder, only past a quarter of a second (the loading rule, 2; `placeholder.tsx`):
 * the hook around `placeholderShown`, so a fast reload never flashes grey blocks.
 */
import { useEffect, useState } from 'react';
import { PLACEHOLDER_DELAY_MS, placeholderShown } from './gate';

/** True once `pending` has held for `delayMs`; false again the moment it ends. */
export function useDelayedPending(pending: boolean, delayMs: number = PLACEHOLDER_DELAY_MS): boolean {
  const [since, setSince] = useState<number | null>(null);
  const [now, setNow] = useState(0);

  useEffect(() => {
    if (!pending) {
      setSince(null);
      return undefined;
    }
    const start = Date.now();
    setSince(start);
    setNow(start);
    const t = setTimeout(() => setNow(Date.now()), delayMs);
    return () => clearTimeout(t);
  }, [pending, delayMs]);

  return placeholderShown({ pending, since, now, delayMs });
}
